export default {
  inTime: {
    mon: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    tue: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    wed: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    thu: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    fri: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sat: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sun: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    }
  },
  overTime: {
    mon: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    tue: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    wed: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    thu: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    fri: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sat: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sun: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    }
  },
  weekend: {
    mon: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    tue: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    wed: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    thu: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    fri: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sat: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sun: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    }
  },
  borderGate: {
    mon: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    tue: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    wed: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    thu: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    fri: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sat: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    },
    sun: {
      AM: {
        start: '',
        end: ''
      },
      PM: {
        start: '',
        end: ''
      }
    }
  }
}
